import { handleRetrieveSingleWebinarRating, handleCreateRating } from "../../../redux/member-slices/rating.slice";
import { handleRetrieveSingleWebinar } from "../../../redux/public-slices/webinar.slice";
import { showDialog, showDialogWithData } from "../../../redux/guest-slices/other.slice";
import { checkUserType, FILE_PATH_URI, handleDownload } from "../../../utils/helper";
import AccessCodeDialog from "../../../components/common/dialogs/AccessCodeDialog";
import { CREATE_BOOKING, GUEST_LOGIN } from "../../../utils/keywords";
import SectionSkeleton from "../../../components/ui/SectionSkeleton";
import SkeletonImage from "../../../components/ui/SkeletonImage";
import { Fragment, Suspense, useEffect, useState } from "react";
import TopBannerA from "../../../components/common/TopBannerA";
import { Link as NavLink, useNavigate, useParams } from "react-router-dom";
import InputField1 from "../../../components/ui/InputField1";
import { ratingSchema } from "../../../utils/velidations";
import { useDispatch, useSelector } from "react-redux";
import Images from "../../../assets/js/Images";
import Icons from "../../../assets/js/Icons";
import { useRef } from "react";
import moment from "moment";
import {
  Alert, Avatar, Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid2 as Grid, IconButton,
  Link, List, ListItem, ListItemText, Rating, Skeleton, Stack, Tooltip, Typography,
} from "@mui/material";

const SingleWebinars = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { webinarId } = useParams();
  const [webinar, setWebinar] = useState({});
  const [ratingValue, setRatingValue] = useState("");
  const [userRating, setUserRating] = useState(null);
  const [subModalOpen, setSubModalOpen] = useState(false);

  const { refresh, loadings } = useSelector((state) => state.otherSlice);
  const { subscription } = useSelector((state) => state.subscriptionSlice);
  const { error: ratingError = null } = useSelector(
    (state) => state.rating || {}
  );
  const descriptionRef = useRef();
  const [errors, setErrors] = useState({});

  const [openDialog, setOpenDialog] = useState(false);
  const [isLinkVisible, setIsLinkVisible] = useState(false);

  const handleGetLinkClick = () => {
    if (!checkUserType()) {
      setSubModalOpen(true);
      return;
    }
    if (!subscription || !["premium", "platinum"].includes(subscription?.plan?.name)) {
      setSubModalOpen(true);
      return;
    }
    if (webinar?.format?.access === "private") {
      handleOpenDialog();
    } else {
      handleShowlink();
    }
  };
  const startTime = new Date(webinar?.schedule?.startTime);
  const duration = webinar?.schedule?.duration || 0;

  const endTime = new Date(startTime.getTime() + duration * 60000);

  const currentTime = new Date();

  const hasEnded = currentTime >= endTime;

  const handleRetrieve = async () => {
    const { webinar } =
      (await dispatch(handleRetrieveSingleWebinar(webinarId)).unwrap()) || {};
    if (webinar) {
      setWebinar(webinar);
    }
  };

  const handleFetchUserRating = async () => {
    try {
      const result = await dispatch(
        handleRetrieveSingleWebinarRating(webinarId)
      ).unwrap();
      const { rating } = result || {};
      if (rating) {
        setUserRating(rating);
      }
    } catch (error) {
      setUserRating(null);
    }
  };
  const handleLogin = () => {
    dispatch(showDialog(GUEST_LOGIN));
  };

  const handleBooking = () => {
    if (checkUserType()) {
      dispatch(
        showDialogWithData({
          type: CREATE_BOOKING,
          data: { webinarId: webinar?._id },
        })
      );
    } else {
      handleLogin();
    }
  };
  const isWebinarTimeReached = () => {
    if (!webinar?.schedule?.startTime) {
      return false;
    }

    const webinarStartTime = moment(webinar.schedule.startTime);
    const currentTime = moment();

    return currentTime.isSameOrAfter(webinarStartTime);
  };
  const handleRatingSubmit = async () => {
    if (!checkUserType()) {
      handleLogin();
      return;
    }

    const description = descriptionRef.current?.value || "";
    const ratingData = {
      rating: ratingValue,
      description,
    };
    const result = ratingSchema.safeParse(ratingData);
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) groupedErrors[key] = [];
        groupedErrors[key].push(issue.message);
      });
      setErrors(groupedErrors); // show errors in UI
      return; // stop submission if invalid
    }
    try {
      await dispatch(
        handleCreateRating({
          webinarId,
          ...ratingData,
        })
      ).unwrap();

      setRatingValue(0);
      if (descriptionRef.current) descriptionRef.current.value = "";
      setErrors({});
      handleFetchUserRating();
    } catch (err) {
      setErrors(err.errors || {});
    }
  };

  useEffect(() => {
    handleRetrieve();
    handleFetchUserRating();
    // eslint-disable-next-line
  }, [refresh, webinarId]);

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const handleAccessCodeSubmit = (isValid) => {
    if (isValid) {
      setIsLinkVisible(true);
    }
  };
  const handleShowlink = () => {
    setIsLinkVisible(true);
  };
  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          currentPage={webinar?.details?.title || "Weibnar Details"}
          bannerImg={
            webinar?.details?.coverImage?.path
              ? FILE_PATH_URI + webinar?.details?.coverImage?.path
              : Images?.blogs
          }
          heading={webinar?.details?.title || "Weibnar Details"}
          menus={[{ name: "Weibnar ", path: "/webinars" }]}
        />
      </Suspense>

      <Box sx={{ py: { xs: 5, lg: 10 }, bgcolor: "#f1f1f1" }}>
        <Container maxWidth={false}>
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, laptop: 8 }}>
              <Box
                sx={{
                  ml: "auto",
                  maxWidth: "1000px",
                }}
              >
                {loadings?.retrieveSingle ? (
                  <Skeleton
                    sx={{
                      width: "100%",
                      minHeight: 350,
                      transform: "none",
                    }}
                  />
                ) : !webinar ? (
                  <Alert
                    sx={{
                      fontSize: "20px",
                      fontWeight: "500",
                      alignItems: "center",
                      fontFamily: "Poppins",
                      ".MuiAlert-message": { p: "0" },
                      ".MuiAlert-icon": { fontSize: "28px" },
                    }}
                    color="error"
                    severity="error"
                  >
                    No Records Found!
                  </Alert>
                ) : (
                  <>
                    <Divider sx={{ my: 2 }} />
                    <Box
                      sx={{
                        gap: 2,
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <Stack
                        spacing={2}
                        direction="row"
                        sx={{
                          alignItems: "center",
                          flexWrap: { xs: "wrap" },
                        }}
                        divider={<Divider flexItem orientation="vertical" />}
                      >
                        <Avatar
                          sx={{ width: 35, height: 35 }}
                          src={webinar?.user?.image}
                        />
                        <Typography
                          fontWeight="600"
                          color="other.color1"
                          textTransform="capitalize"
                        >
                          {webinar?.user?.fullName}
                        </Typography>
                      </Stack>

                      <Divider
                        flexItem
                        orientation="vertical"
                        sx={{
                          display: { xs: "none", sm: "block" },
                        }}
                      />

                      <Stack
                        spacing={2}
                        direction="row"
                        sx={{
                          alignItems: "center",
                          flexWrap: { xs: "wrap" },
                        }}
                        divider={<Divider flexItem orientation="vertical" />}
                      >
                        <Typography
                          color="other.color2"
                          fontSize={{ xs: 14, md: 16 }}
                        >
                          {webinar?.seats?.booked || 0} Seats booked
                        </Typography>
                        <Typography
                          color={
                            webinar?.seats?.available < 10
                              ? "error.main"
                              : "other.color2"
                          }
                          fontSize={{ xs: 14, md: 16 }}
                        >
                          {webinar?.seats?.available < 10 && "Hurry up!"}{" "}
                          {webinar?.seats?.available || 0} Seats left
                        </Typography>
                      </Stack>
                    </Box>

                    <Divider sx={{ mt: 2 }} />

                    <Typography
                      sx={{
                        my: 2,
                        width: "100%",
                        overflow: "hidden",
                        WebkitLineClamp: 1,
                        color: "other.color1",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                      }}
                      fontSize={28}
                      fontWeight="700"
                    >
                      {webinar?.details?.title}
                    </Typography>

                    <Box
                      sx={{
                        width: "100%",
                        overflow: "hidden",
                        borderRadius: "6px",
                        aspectRatio: "1/0.5",
                      }}
                    >
                      <SkeletonImage
                        src={FILE_PATH_URI + webinar?.details?.coverImage?.path}
                      />
                    </Box>

                    <Box
                      sx={{ color: "other.color1", mt: 3 }}
                      dangerouslySetInnerHTML={{
                        __html: webinar?.details?.description,
                      }}
                    />
                    {/* Additional Webinar Details */}
                    <Box sx={{ mt: 3 }}>
                      <Grid container spacing={6}>
                        <Grid>
                          <Typography
                            fontSize={20}
                            fontWeight="600"
                            color="other.color1"
                            sx={{ mb: 2 }}
                          >
                            Webinar Details
                          </Typography>
                          <List>
                            <ListItem sx={{ py: 0.5 }}>
                              <ListItemText
                                primary="Number of Seats"
                                secondary={`${webinar?.seats?.available || 0} / ${webinar?.details?.numberOfSeats} Seats left`}
                              />
                            </ListItem>
                            {/* <ListItem sx={{ py: 0.5 }}>
                              <ListItemText
                                primary="Target Audience"
                                secondary={webinar?.details?.targetAudience?.join(
                                  ", "
                                )}
                              />
                            </ListItem> */}
                            {/* <ListItem sx={{ py: 0.5 }}>
                              <ListItemText
                                primary="Format"
                                secondary={webinar?.format?.format}
                              />
                            </ListItem> */}
                            <ListItem sx={{ py: 0.5 }}>
                              <ListItemText
                                primary="Webinar Link"
                                secondary={
                                  <>
                                    <Tooltip 
                                      title={
                                        !isWebinarTimeReached() 
                                          ? "The webinar has not started yet. You will be able to access the link once the webinar starts." 
                                          : ""
                                      }
                                      placement="top"
                                    >
                                      <span style={{ display: 'inline-block', marginTop: '16px' }}>
                                        <Button
                                          disabled={!isWebinarTimeReached()}
                                          variant="contained"
                                          onClick={handleGetLinkClick}
                                        >
                                          Get Link
                                        </Button>
                                      </span>
                                    </Tooltip>

                                    {isLinkVisible && (
                                      <Box mt={2}>
                                        <Link
                                          target="_blank"
                                          component={NavLink}
                                          rel="noopener noreferrer"
                                          style={{ color: "inherit" }}
                                          to={webinar?.resources?.webinarLink}
                                        >
                                          {webinar?.resources?.webinarLink}
                                        </Link>
                                      </Box>
                                    )}
                                  </>
                                }
                              />
                            </ListItem>

                            <AccessCodeDialog
                              open={openDialog}
                              onClose={handleCloseDialog}
                              onSubmit={handleAccessCodeSubmit}
                              accessCode={webinar?.accessCode}
                            />
                            {webinar?.isBooked && (
                              <ListItem sx={{ py: 0.5 }}>
                                <ListItemText
                                  primary="Status"
                                  secondary={webinar?.isBooked ? "Booked" : "Schedule"}
                                />
                              </ListItem>
                            )}
                            <ListItem sx={{ py: 0.5 }}>
                              <ListItemText
                                primary="Time Zone"
                                secondary={webinar?.schedule?.timeZone?.toUpperCase()}
                              />
                            </ListItem>
                          </List>
                        </Grid>
                        <Grid>
                          <Typography
                            fontSize={20}
                            fontWeight="600"
                            color="#F1F1F1"
                            sx={{ mt: 0, mb: 2 }}
                          >
                            {webinar?.isBooked ? "Booked" : "Schedule"}
                          </Typography>
                          <List>
                            <ListItem sx={{ py: 0.5 }}>
                              <ListItemText
                                primary="Date"
                                secondary={moment(
                                  webinar?.schedule?.startTime
                                ).format("MMM DD YYYY")}
                              />
                            </ListItem>
                            <ListItem sx={{ py: 0.5 }}>
                              <ListItemText
                                primary="Start Time"
                                secondary={moment(
                                  webinar?.schedule?.startTime
                                ).format("  hh:mm A")}
                              />
                            </ListItem>
                            <ListItem sx={{ py: 0.5 }}>
                              <ListItemText
                                primary="Duration"
                                secondary={`${webinar?.schedule?.duration} minutes`}
                              />
                            </ListItem>
                          </List>
                        </Grid>
                      </Grid>
                    </Box>
                    {!webinar?.isBooked && (
                      <Box sx={{ mb: 2 }}>
                        <Button
                          variant="contained"
                          sx={{ minWidth: 150 }}
                          onClick={handleBooking}
                          disabled={webinar?.isBooked}
                        >
                          {webinar?.isBooked ? "Booked" : "Book now"}
                        </Button>
                      </Box>
                    )}
                    <Divider />
                    {hasEnded && webinar?.isBooked && (
                      <Box sx={{ mt: 2 }}>
                        <Grid>
                          <Typography
                            fontSize={20}
                            fontWeight="600"
                            color="other.color1"
                            sx={{ mt: 0, mb: 2 }}
                          >
                            Rating
                          </Typography>
                          {ratingError ? (
                            <Typography color="error" variant="body2">
                              {ratingError}
                            </Typography>
                          ) : userRating ? (
                            <Box
                              sx={{
                                p: 3,
                                border: "1px solid #e0e0e0",
                                borderRadius: 2,
                                bgcolor: "#f9f9f9",
                                width: "100%",
                                maxWidth: 400,
                              }}
                            >
                              <Typography
                                variant="subtitle1"
                                fontWeight="600"
                                sx={{ mb: 1 }}
                              >
                                Rating : {userRating?.rating}/5
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  mb: 1,
                                }}
                              >
                                <Rating
                                  value={userRating?.rating}
                                  readOnly
                                  size="large"
                                />
                              </Box>
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                p: 3,
                                border: "1px solid #e0e0e0",
                                borderRadius: 2,
                                width: "100%",
                                maxWidth: 400,
                              }}
                            >
                              <Typography
                                variant="subtitle1"
                                fontWeight="600"
                                sx={{ mb: 2 }}
                              >
                                Rate this webinar
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 2,
                                }}
                              >
                                <Box>
                                  <Typography variant="body2" sx={{ mb: 1 }}>
                                    Click on stars to rate:
                                  </Typography>
                                  <Rating
                                    name="webinar-rating"
                                    value={ratingValue}
                                    onChange={(event, newValue) => {
                                      setRatingValue(newValue);
                                    }}
                                    size="large"
                                    precision={1}
                                  />
                                  {errors?.rating && (
                                    <Typography
                                      color="error"
                                      variant="body2"
                                      sx={{ mt: 1 }}
                                    >
                                      {errors.rating}
                                    </Typography>
                                  )}

                                  <InputField1
                                    name="description"
                                    label="Feedback"
                                    type="textarea"
                                    placeholder="Write your feedback here..."
                                    rows={4}
                                    errors={errors}
                                    errText={errors.description}
                                    inputRef={descriptionRef}
                                  />
                                </Box>
                                <Button
                                  variant="contained"
                                  onClick={handleRatingSubmit}
                                  disabled={ratingValue === 0}
                                  sx={{ alignSelf: "flex-start" }}
                                >
                                  Submit Rating
                                </Button>
                              </Box>
                            </Box>
                          )}
                        </Grid>
                      </Box>
                    )}
                  </>
                )}
              </Box>
            </Grid>

            <Grid
              size={{ xs: 12, laptop: 4 }}
              sx={{ position: "relative", minHeight: 100 }}
            >
              {hasEnded &&
                checkUserType() &&
                webinar?.resources?.files?.length > 0 && (
                  <>
                    <Typography variant="subtitle1" fontWeight={600} mb={2}>
                      Download the below given resources:
                    </Typography>

                    <Grid
                      container
                      spacing={2}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "1fr",
                          sm: "1fr 1fr",
                          md: "1fr 1fr ",
                        },
                        gap: 2,
                      }}
                    >
                      {webinar.resources.files.map((file, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            bgcolor: "white",
                            boxShadow: "0 0 10px 0 #00000025",
                            borderRadius: 2,
                            overflow: "hidden",
                            p: 1.5,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <SkeletonImage
                              sx={{
                                width: 40,
                                height: 40,
                                objectFit: "contain",
                              }}
                              src={Images.file}
                            />
                            <Typography
                              sx={{
                                fontSize: 14,
                                fontWeight: 500,
                                flexGrow: 1,
                                wordBreak: "break-word",
                              }}
                            >
                              {file?.originalName}
                            </Typography>
                          </Box>

                          <IconButton
                            sx={{
                              border: "1px solid",
                              color: "primary.main",
                              bgcolor: "white !important",
                              borderColor: "primary.main",
                            }}
                            size="small"
                            onClick={() =>
                              handleDownload(FILE_PATH_URI + file?.path)
                            }
                          >
                            <Icons.CloudDownloadSolid />
                          </IconButton>
                        </Box>
                      ))}
                    </Grid>
                  </>
                )}
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Dialog open={subModalOpen} onClose={() => setSubModalOpen(false)}>
        <DialogTitle sx={{ textAlign: "center", fontWeight: "600", pt: 3 }}>
          Subscription Required
        </DialogTitle>
        <DialogContent>
          <Typography textAlign="center" color="text.secondary" maxWidth={400} mx="auto">
            To watch and access webinars, please purchase a Premium or Platinum subscription plan.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3, gap: 1 }}>
          <Button variant="outlined" onClick={() => setSubModalOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setSubModalOpen(false);
              navigate("/pricing");
            }}
            sx={{ bgcolor: "#2F4250", color: "#fff", "&:hover": { bgcolor: "#22313D" } }}
          >
            Purchase Subscription
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default SingleWebinars;